<h2 class=" d-flex justify-content-center" mat-dialog-title> Enviar Ticket a un Amigo </h2>

<div *ngIf="loading" class="col-12  mt-2 mb-2 d-flex justify-content-center align-items-center">
  <mat-progress-spinner class="example-margin" color="primary" mode="indeterminate"></mat-progress-spinner>
</div>

<mat-dialog-content *ngIf="!loading" class="mat-typography row  d-flex justify-content-center">


  <div class="col-12 d-flex justify-content-center">
    <p class="col-12 justifyText">
      Para poder enviar ticket, tu amigo tiene que tener cuenta creada en esta plataforma.
    </p>
  </div>
  <mat-form-field class="col-12" appearance="outline">
    <mat-label> Correo</mat-label>
    <input [(ngModel)]="emailFriend" id="address" matInput placeholder="Direccion del evento" required="required"
      type="text">
    <mat-icon matSuffix>email</mat-icon>
  </mat-form-field>

  <h2 class=" d-flex justify-content-center" mat-dialog-title> Amigos Frecuentes </h2>

  <div *ngIf="!friends.length" class=" col-12 d-flex justify-content-center">
    <p class="col-12 justifyText">
      Para poder visualizar amigos frencuentes debes haber enviado alguna vez un ticket.
    </p>
  </div>
  <div *ngFor=" let friend of friends" (click)="clickFriend(friend)"
    class="col-12 col-sm-12 mt-1 d-flex justify-content-center ">

    <button class="col-12" mat-raised-button color="primary">
      <!-- <mat-icon>email</mat-icon>  -->
      {{friend}}


    </button>


  </div>





</mat-dialog-content>



<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="closeDialog(false)">Cerrar</button>
  <button mat-button type="button" [disabled]="!emailFriend" (click)="sendTicketToFriend()" cdkFocusInitial>Enviar
  </button>
</mat-dialog-actions>